export const attendanceDataTrainer = [
  {
    photo: "https://prod-discovery.edx-cdn.org/media/course/image/b43f2cde-b38f-4717-8399-033f0aba61f4-bd6f44692f21.small.png",
    name: "Selena Ourania",
    row1: {
      sessions: "Session 1",
      attendance: "Present",
    },
    row2: {
      sessions: "Session 2",
      attendance: "Absent",
    },
  },
  {
    photo: "https://prod-discovery.edx-cdn.org/media/course/image/b43f2cde-b38f-4717-8399-033f0aba61f4-bd6f44692f21.small.png",
    name: "Selena Ourania",
    row1: {
      sessions: "Session 1",
      attendance: "Present",
    },
    row2: {
      sessions: "Session 2",
      attendance: "Absent",
    },
  },
  {
    photo: "https://prod-discovery.edx-cdn.org/media/course/image/b43f2cde-b38f-4717-8399-033f0aba61f4-bd6f44692f21.small.png",
    name: "Selena Ourania",
    row1: {
      sessions: "Session 1",
      attendance: "Present",
    },
    row2: {
      sessions: "Session 2",
      attendance: "Absent",
    },
  },
  {
    photo: "https://prod-discovery.edx-cdn.org/media/course/image/b43f2cde-b38f-4717-8399-033f0aba61f4-bd6f44692f21.small.png",
    name: "Selena Ourania",
    row1: {
      sessions: "Session 1",
      attendance: "Present",
    },
    row2: {
      sessions: "Session 2",
      attendance: "Absent",
    },
  },
  {
    photo: "https://prod-discovery.edx-cdn.org/media/course/image/b43f2cde-b38f-4717-8399-033f0aba61f4-bd6f44692f21.small.png",
    name: "Selena Ourania",
    row1: {
      sessions: "Session 1",
      attendance: "Present",
    },
    row2: {
      sessions: "Session 2",
      attendance: "Absent",
    },
  },
];

export const tableColumns = [
  "Name",
  "Sessions",
  "Attendance",
];
